import { call, put, takeEvery } from 'redux-saga/effects'

import {
  GET_LISTUSERS_REQUESTED,
  GET_CURRENTUSER_REQUESTED,
  GET_FEATURES
} from '../actions/actionTypes'
import {
  getListUsersSuccess,
  getListUsersFailed,
  getCurrentUserSuccess,
  getCurrentUserFailed,
  getConfigurationSuccess
} from '../actions/userAction'
import { messages } from '../../helpers/messages'
import { userService } from '../../services/user-service'
import { USER_INFO } from '../../constants/localStorageConstants';
import {authService} from "../../services/auth-service";

const getConfigurationUser = async () =>
   await userService.getConfiguration()
     .then(data => data)
       .catch(error => {
         if (error.response) {
           let errorData = error.response.data
           let commonError = messages["0"]
           if (errorData.errorCode) {
             commonError = messages[errorData.errorCode]
           }
           throw commonError
         }
       })

const getListUsers = async listUserId =>
  await userService
    .listUsersByIds(listUserId)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getCurrentUser = async () =>
  await userService
    .getCurrentUser()
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })


function* fetchConfiguration() {
  try {
    const config = yield call(() => getConfigurationUser())
    yield put(getConfigurationSuccess(config))
  } catch (error) {
    yield put(getListUsersFailed(error))
  }
}

function* fetchGetListUsers({ listUserId }) {
  try {
    const listUsers = yield call(() => getListUsers(listUserId))
    yield put(getListUsersSuccess(listUsers))
  } catch (error) {
    yield put(getListUsersFailed(error))
  }
}

function* fetchGetCurrentUser() {
  try {
    const user = yield call(getCurrentUser)
    if (user.active){
      localStorage.setItem(USER_INFO, JSON.stringify(user));
      yield put(getCurrentUserSuccess(user))
    } else {
      authService.logout()
    }
  } catch (error) {
    yield put(getCurrentUserFailed(error))
  }
}

function* getConfigurationSaga() {
  yield takeEvery(GET_FEATURES, fetchConfiguration)
}

function* getListUsersSaga() {
  yield takeEvery(GET_LISTUSERS_REQUESTED, fetchGetListUsers)
}

function* getCurrentUserSaga() {
  yield takeEvery(GET_CURRENTUSER_REQUESTED, fetchGetCurrentUser)
}

export {
  getListUsersSaga,
  getListUsers,
  getCurrentUserSaga,
  getConfigurationSaga
}
